<header class="mt-4">
  <!-- Heading -->
  <h1>
    {{ title }}
    @if (helperText) {
    <hlm-icon
      name="INFORMATION"
      class="opacity-80 align-bottom"
      [matTooltip]="helperText"
    ></hlm-icon>
    }
  </h1>

  <!-- Breadcrumbs -->
  <nav class="flex flex-row gap-x-1 mb-4 items-center">
    @for (breadcrumb of breadcrumbs; track breadcrumb; let isLastItem = $last) {
    <a
      class="text-xs last:no-underline"
      [routerLink]="isLastItem ? null : breadcrumb.link"
      [ngClass]="isLastItem ? 'opacity-30' : ''"
      >{{ breadcrumb.label }}</a
    >@if (!isLastItem) {
    <span class="select-none opacity-60 text-xs">/</span>
    } }
  </nav>
</header>
